const flattenGroupedMediaUploads = (mediaGroups) =>
  mediaGroups.flatMap((group) =>
    Array.isArray(group?.videoImageMapUpload)
      ? group.videoImageMapUpload
      : [],
  );

const getMediaList = (source, key) =>
  Array.isArray(source?.[key]) ? source[key] : [];

const hasGroupedMediaShape = (mediaList) =>
  mediaList.some((mediaItem) => Array.isArray(mediaItem?.videoImageMapUpload));

export const getCartItemMediaUploads = (cartItem) => {
  const newMediaGroups = [
    ...getMediaList(cartItem, "videoImageMapNew"),
    ...getMediaList(cartItem?.product, "videoImageMapNew"),
  ];

  if (newMediaGroups.length > 0) {
    return flattenGroupedMediaUploads(newMediaGroups);
  }

  const videoImageMap = [
    ...getMediaList(cartItem, "videoImageMap"),
    ...getMediaList(cartItem?.product, "videoImageMap"),
  ];

  if (hasGroupedMediaShape(videoImageMap)) {
    return flattenGroupedMediaUploads(videoImageMap);
  }

  return videoImageMap;
};

export const getUploadImageUrl = (upload) => {
  const rawUrl =
    upload?.s3Key ||
    upload?.uploadThumbnailUrl ||
    upload?.uploadUrl ||
    upload?.url ||
    "";

  if (!rawUrl) return "";
  if (/^https?:\/\//i.test(rawUrl)) return rawUrl;

  const baseUrl = process.env.NEXT_PUBLIC_SECURED_URL || "";

  if (!baseUrl) return rawUrl;

  return `${baseUrl.replace(/\/+$/, "")}/${String(rawUrl).replace(/^\/+/, "")}`;
};
